export const INICIALIZED_SUCCESS = 'INICIALIZED_SUCCESS';
export const TOGGLE_ACTIVE_LEFT_MENU = 'TOGGLE_ACTIVE_LEFT_MENU';
export const SET_MESSENGERS_LIST = 'SET_MESSENGERS_LIST';
export const SET_SAVING_STATUS = 'SET_SAVING_STATUS';
export const TOGGLE_PHOTO_IS_DONE = 'TOGGLE_PHOTO_IS_DONE';
